import { render, staticRenderFns } from "./CreateCallingCampaign.vue?vue&type=template&id=0c554afa&scoped=true&"
import script from "./CreateCallingCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateCallingCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateCallingCampaign.vue?vue&type=style&index=0&id=0c554afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c554afa",
  null
  
)

export default component.exports